import React from 'react';

import { Badge, Button, Table, TableFiltering, TableSorting, TablePagination } from 'AWS-UI-Components-React';

import { downloadFile, toDownloadFormat } from '../../../utilities';
import { TokenGroupDisplay } from '../../common/token_group_display';

const tablePageSize = 75;

export class GLPLMappingTable extends React.Component {
  constructor(props) {
    super(props);
  }

  getColumnDefinitions = (productGroupIdToProductLines) => {
    return [
      {
        id: 'id',
        header: 'Id',
        minWidth: '150px',
        cell: (item) => {
          return (
            <span>
              {item.id} {this.getBadges(item, productGroupIdToProductLines)}
            </span>
          );
        },
      },
      {
        id: 'name',
        header: 'Name',
        minWidth: '250px',
        cell: (item) => item.name,
      },
      {
        id: 'productLines',
        header: 'Product Lines',
        cell: (item) => this.productLinesDisplay(item, productGroupIdToProductLines),
      },
    ];
  };

  getBadges = (productGroup, productGroupIdToProductLines) => {
    return !productGroupIdToProductLines[productGroup.id] ? (
      <span key={productGroup.id}>
        <Badge color={'grey'} content={'Unmapped'} />
      </span>
    ) : null;
  };

  productLinesDisplay = (productGroup, productGroupIdToProductLines) => {
    const productLines = productGroupIdToProductLines[productGroup.id];
    const productLineDisplayItems = (productLines || []).map((productLine) => {
      return {
        label: `${productLine.name} (${productLine.id})`,
      };
    });

    return (
      <div className="awsui-grid">
        <div className="awsui-util-pt-m awsui-util-mb-s">
         <div className="awsui-row">
            <TokenGroupDisplay items={productLineDisplayItems} />
         </div>
        </div>
      </div>
    );
  };

  productGroupIdToProductLines = (productGroupsById, productLinesById) => {
    let productGroupIdToProductLines = {};

    for (let id of Object.keys(productLinesById)) {
      const productLine = productLinesById[id];
      const gls = productLine.gls || [];
      for (let gl of gls) {
        const existingMapping = productGroupIdToProductLines[gl];
        const productGroup = productGroupsById[gl];
        if (productGroup) {
          productGroupIdToProductLines[gl] = (existingMapping ? existingMapping : []).concat(productLine);
        }
      }
    }

    return productGroupIdToProductLines;
  };

  onClickDownloadData = (columnDefinitions, productGroups, productGroupIdToProductLines) => {
    const productGroupsWithProductLines = productGroups.map((productGroup) => {
      const productLines = (productGroupIdToProductLines[productGroup.id] || [])
        .map((productLine) => `${productLine.name}(${productLine.id})`)
        .join(',');

      return {
        ...productGroup,
        productLines,
      };
    });
    const data = toDownloadFormat(columnDefinitions, productGroupsWithProductLines);
    downloadFile(data, 'ProductGroups.xls');
  };

  render() {
    const { productGroupsById, productLinesById } = this.props;
    const productGroupIdToProductLines = this.productGroupIdToProductLines(productGroupsById, productLinesById);
    const productGroups = Object.values(productGroupsById);
    const columnDefinitions = this.getColumnDefinitions(productGroupIdToProductLines);

    return (
      <div id="gl-pl-mapping-table">
        <Table
          columnDefinitions={columnDefinitions}
          items={productGroups}
          header={
            <div className="awsui-util-action-stripe">
              <div className="awsui-util-action-stripe-title">
                <h2>Product Groups</h2>
              </div>
              <div className="awsui-util-action-stripe-group">
                <Button
                  text="Download Data"
                  onClick={() =>
                    this.onClickDownloadData(columnDefinitions, productGroups, productGroupIdToProductLines)
                  }
                  icon="download"
                />
              </div>
            </div>
          }
          loading={!productGroups}
          loadingText={'Loading product groups...'}
          stickyHeader
        >
          <TableFiltering filteringPlaceholder="Filter product groups" />
          <TableSorting
            sortingColumn="id"
            sortableColumns={[
              { id: 'id', field: 'id' },
              { id: 'name', field: 'name' },
              { id: 'productLines', field: 'productLines' },
            ]}
          />
          <TablePagination pageSize={tablePageSize} />
        </Table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/config_central/gl_pl_mapping/gl_pl_mapping_table.jsx